<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    
                    <div class="hidden-lg hidden-md hidden-sm hidden-xl">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>
                    <div class="hidden-xs">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>      

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs hidden-md">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>                                  
            
                    <div class="row">

                        <div class="col-xs-12 col-xl-8 col-lg-8">
                            <div class="row">
                                <div class="col-xs-12 col-xl-12">
                                    <div class="dashboard-box margin-top-0 cards">
                                        <div class="content">
                                            <h5 class="block-title">
                                                <i class="las la-comment-dots"></i>
                                                Novidades

                                                <small style="float: right; font-size: 11px; color: #666">v{{$root.config.versao}}</small>
                                            </h5>
                                            <ul class="dashboard-box-list">
                                                
                                                <li>
                                                    <a class="job-listing card2">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description" style="padding-top: 0px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <p style="line-height: 110%; padding-top: 0px; margin-top: 3px;">
                                                                            Seja bem vindo(a) {{$root.user.nome}}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li v-for="(item, index) in data.mural.itens">
                                                    <a class="job-listing card2">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description" style="padding-top: 0px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <p style="line-height: 110%; padding-top: 0px; margin-top: 3px;">
                                                                            {{item.objeto.conteudo}}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>  
                                </div>                          

                                <div class="col-xs-12 col-lg-12 col-xl-12" v-show="$root.user.tipo == 'contratante'">
                                    <div class="dashboard-box margin-top-0 cards" v-if="$root.logged">
                                        <div class="content" v-if="data.agendamentos.itens.length > 0">
                                            <h5 class="block-title">
                                                <i class="las la-calendar"></i>
                                                Próximos agendamentos
                                            </h5>
                                            <ul class="dashboard-box-list">
                                                
                                                <li v-for="(item, index) in agendamentosProximos">
                                                    <router-link v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" :to="{'name': 'Teleconsulta', 'query': {'NR_SEQUENCIA': item.NR_SEQUENCIA}}" class="job-listing card2">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <i class="las la-angle-right chevron-right hidden-xl hidden-md" style="opacity: 0.5"></i>
                                                                        
                                                                        <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                            <i class="las la-clock" style="opacity: 0.5;"></i>    
                                                                            {{item.HR_INICIO | formatDate}}h
                                                                        </h3>
                                                                        <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                            <i class="las la-user"></i>
                                                                            {{item.NM_MEDICO_AGENDA}}
                                                                        </small>
                                                                        <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                            {{item.DS_STATUS_AGENDA}}
                                                                        </span>

                                                                        <small v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" style="color: #000">
                                                                            <i class="las la-video"></i>
                                                                            Teleconsulta
                                                                        </small>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                    <router-link v-if="item.DS_CLASSIF_AGENDA != 'Consulta Online'" :to="{'name': 'Agendamentos'}" class="job-listing card2" >
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <i class="las la-angle-right chevron-right hidden-xl hidden-md" style="opacity: 0.5"></i>
                                                                        
                                                                        <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                            <i class="las la-clock" style="opacity: 0.5;"></i>    
                                                                            {{item.HR_INICIO | formatDate}}h
                                                                        </h3>
                                                                        <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                            <i class="las la-user"></i>
                                                                            {{item.NM_MEDICO_AGENDA}}
                                                                        </small>
                                                                        <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                            {{item.DS_STATUS_AGENDA}}
                                                                        </span>

                                                                        <small v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" style="color: #000">
                                                                            <i class="las la-video"></i>
                                                                            Teleconsulta
                                                                        </small>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>  
                                    <div class="dashboard-box margin-top-0 margin-bottom-25 cards" v-show="!$root.logged">
                                        <div class="content">
                                            <h5 class="block-title">
                                                <i class="las la-user"></i>
                                                Cadastre-se ou faça login
                                            </h5>
                                            <ul class="dashboard-box-list">
                                                
                                                <li>
                                                    <router-link :to="{'name': 'Login'}" class="button small block-mobile white" >
                                                        Acessar conta <i class="las la-arrow-right"></i>
                                                    </router-link>
                                                </li>

                                            </ul>
                                        </div>
                                    </div>                              
                                    <!-- <div class="hidden-xs margin-top-20"></div>                          -->
                                </div>
                              
                                <div class="col-xs-12 col-xl-12 col-lg-12" v-if="$root.user.tipo == 'contratante'">
                                    <div class="row" v-if="$root.config['menu']">

                                        <div v-if="$root.config['menu'].paciente.agendarConsulta" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Profissionais'}" class="button-menu shadow">
                                                <img src="static/images/icones/stethoscope.png">
                                                Agendar consulta
                                            </router-link>
                                        </div>

                                        <div v-if="$root.config['menu'].paciente.meusAgendamentos" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                                <img src="static/images/icones/calendar.png">
                                                Meus agendamentos
                                            </router-link>
                                        </div>

                                        <div v-if="$root.config['menu'].paciente.dicasSemanais" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                                <img src="static/images/icones/writing.png">
                                                Dicas semanais
                                            </router-link>
                                        </div>

                                        <div v-if="$root.config['menu'].paciente.receitasAtestados" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                                <img src="static/images/icones/note.png">
                                                Receitas e atestados
                                            </router-link>
                                        </div>

                                        <div v-if="$root.config['menu'].paciente.meusExames" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Exames'}" class="button-menu shadow">
                                                <img src="static/images/icones/archives.png">
                                                Meus exames
                                            </router-link>
                                        </div>

                                        <div v-if="$root.config['menu'].paciente.meusDocumentos" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Arquivos'}" class="button-menu shadow">
                                                <img src="static/images/icones/diary.png">
                                                Meus documentos
                                            </router-link>
                                        </div>

                                        <div v-if="$root.config['menu'].paciente.ged" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Ged'}" class="button-menu shadow">
                                                <img src="static/images/icones/diary.png">
                                                GED
                                            </router-link>
                                        </div>                                        

                                        <div v-if="$root.config['menu'].paciente.minhaConta" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                                <img src="static/images/icones/profile.png">
                                                Minha conta
                                            </router-link>
                                        </div>

                                        <div v-if="$root.config['menu'].paciente.sair" class="col-xs-6 col-xl-4 col-md-6 col-lg-3">
                                            <a v-on:click="$root.exit" class="button-menu shadow">
                                                <img src="static/images/icones/warranty.png">
                                                Sair
                                            </a>
                                        </div>

                                        <div class="col-xs-12 col-xl-6 contato hidden-xl hidden-lg" v-show="$root.user.tipo == 'contratante'">
                                            <a class="button-menu shadow" style="min-height: 17vh; height: auto; padding-top: 20px;">
                                                <div class="row">
                                                    <div class="col-xl-5 col-xs-4">
                                                        <center>
                                                            <img src="static/images/icones/quality.png">
                                                        </center>
                                                    </div>
                                                    <div class="col-xl-7 col-xs-7" style="text-align: left; padding-top: 5px; padding-left: 15px;">
                                                        <h4 style="font-size: 120%">Canais de contato</h4>
                                                        <small>
                                                            Entre em contato conosco
                                                        </small>
                                                        <div style="height: 10px"></div>
                                                        <a :href="'tel:' + $root.config.telefone" target="_blank" class="social">
                                                            <img src="static/images/icones/phone.png">
                                                        </a>
                                                        <a :href="$root.config.whatsapp" target="_blank" class="social">
                                                            <img src="static/images/icones/whatsapp.png">
                                                        </a>
                                                        <!-- <a :href="$root.config.instagram" target="_blank" class="social">
                                                            <img src="static/images/icones/instagram.png">
                                                        </a>
                                                        <a :href="$root.config.facebook" target="_blank" class="social">
                                                            <img src="static/images/icones/facebook.png">
                                                        </a> -->  
        <!--                                                 <a href="" class="social">
                                                            <img src="static/images/icones/email.png">
                                                        </a>         -->                                                                                               
                                                        <div style="height: 10px"></div>

                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                    </div>                            
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 contato hidden-xs hidden-md margin-top-30" v-show="$root.user.tipo == 'contratante'">
                            <a class="button-menu shadow" style="min-height: 17vh; height: auto; padding-top: 20px;">
                                <div class="row">
                                    <div class="col-xl-4 col-xs-4">
                                        <center>
                                            <img src="static/images/icones/quality.png">
                                        </center>
                                    </div>
                                    <div class="col-xl-7 col-xs-7" style="text-align: left; padding-top: 5px; padding-left: 15px;">
                                        <h4 style="font-size: 120%">Canais de contato</h4>

                                        <div style="height: 10px"></div>
                                        <a :href="$root.config.telefone" target="_blank" class="social">
                                            <img src="static/images/icones/phone.png">
                                        </a>
                                        <a :href="$root.config.whatsapp" target="_blank" class="social">
                                            <img src="static/images/icones/whatsapp.png">
                                        </a>
<!--                                         <a :href="$root.config.instagram" target="_blank" class="social">
                                            <img src="static/images/icones/instagram.png">
                                        </a>
                                        <a :href="$root.config.facebook" target="_blank" class="social">
                                            <img src="static/images/icones/facebook.png">
                                        </a>   -->
    <!--                                                 <a href="" class="social">
                                            <img src="static/images/icones/email.png">
                                        </a>         -->                                                                                               
                                        <div style="height: 10px"></div>

                                    </div>
                                </div>
                            </a>
                        </div>    
                        <div class="col-xs-12 col-xl-4 margin-bottom-15 hidden-xs hidden-md">
                        </div>                                              
                    </div>

                    <!-- admin -->
                    <div class="row" v-show="$root.user.tipo == 'admin'">
                           
                        <div class="col-xs-12">

                            <div class="row">

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'PendentesFormularios'}" class="button-menu shadow">
                                        <img src="static/images/icones/crisis.png">
                                        Formulários pendentes
                                        <span class="dashboard-status-button color-orange badge" v-if="data.formulariosPendentes.total">{{data.formulariosPendentes.total}}</span>
                                    </router-link>
                                </div> 

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                        <img src="static/images/icones/writing.png">
                                        Dicas semanais
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                        <img src="static/images/icones/calendar.png">
                                        Agendamentos
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Pacientes'}" class="button-menu shadow">
                                        <img src="static/images/icones/users.png">
                                        Pacientes
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                        <img src="static/images/icones/note.png">
                                        Receitas e atestados
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Campanhas'}" class="button-menu shadow">
                                        <img src="static/images/icones/tick.png">
                                        Campanhas
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Mural'}" class="button-menu shadow">
                                        <img src="static/images/icones/document.png">
                                        Mural de recados
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'UsuariosGeral'}" class="button-menu shadow">
                                        <img src="static/images/icones/user2.png">
                                        Usuários
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Configuracoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/gear.png">
                                        Configurações
                                    </router-link>
                                </div>   

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'FinanceiroSolicitacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/receipt.png">
                                        Aprovações
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'FinanceiroMovimentacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/refund.png">
                                        Orçamento
                                    </router-link>
                                </div>                                

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'HonorariosMedicos'}" class="button-menu shadow">
                                        <img src="static/images/icones/wallet.png">
                                        Honorários Médicos
                                    </router-link>
                                </div> 

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'RelatorioFormularios'}" class="button-menu shadow">
                                        <img src="static/images/icones/research.png">
                                        Relatório de formulários
                                    </router-link>
                                </div> 

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Formularios'}" class="button-menu shadow">
                                        <img src="static/images/icones/engineering.png">
                                        Gerenciar formulários
                                    </router-link>
                                </div>                                 

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                                <div  class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <a v-on:click="$root.exit" class="button-menu shadow">
                                        <img src="static/images/icones/warranty.png">
                                        Sair
                                    </a>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>

                    <div class="row" v-show="$root.user.tipo == 'gerente'">
                           
                        <div class="col-xs-12">

                            <div class="row">

                                <div v-if="$root.config['menu'].gerente.agendarConsulta" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Profissionais'}" class="button-menu shadow">
                                        <img src="static/images/icones/stethoscope.png">
                                        Agendar consulta
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].gerente.meusAgendamentos" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                        <img src="static/images/icones/calendar.png">
                                        Meus agendamentos
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].gerente.dicasSemanais" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                        <img src="static/images/icones/writing.png">
                                        Dicas semanais
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].gerente.receitasAtestados" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                        <img src="static/images/icones/note.png">
                                        Receitas e atestados
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].gerente.meusExames" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Exames'}" class="button-menu shadow">
                                        <img src="static/images/icones/archives.png">
                                        Meus exames
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].gerente.meusDocumentos" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Arquivos'}" class="button-menu shadow">
                                        <img src="static/images/icones/diary.png">
                                        Meus documentos
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].gerente.ged" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Ged'}" class="button-menu shadow">
                                        <img src="static/images/icones/diary.png">
                                        GED
                                    </router-link>
                                </div>        

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].gerente.pacientes">
                                    <router-link :to="{'name': 'Pacientes'}" class="button-menu shadow">
                                        <img src="static/images/icones/users.png">
                                        Pacientes
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].gerente.aprovacaoOrcamentaria">
                                    <router-link :to="{'name': 'FinanceiroSolicitacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/receipt.png">
                                        Aprovações
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].gerente.alteracaoOrcamentaria">
                                    <router-link :to="{'name': 'FinanceiroMovimentacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/refund.png">
                                        Orçamento
                                    </router-link>
                                </div>                                                               

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].gerente.minhaConta">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                                <div  class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].gerente.sair">
                                    <a v-on:click="$root.exit" class="button-menu shadow">
                                        <img src="static/images/icones/warranty.png">
                                        Sair
                                    </a>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>

                    <div class="row" v-show="$root.user.tipo == 'controladoria'">
                           
                        <div class="col-xs-12">

                            <div class="row">

                                <div v-if="$root.config['menu'].controladoria.agendarConsulta" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Profissionais'}" class="button-menu shadow">
                                        <img src="static/images/icones/stethoscope.png">
                                        Agendar consulta
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].controladoria.meusAgendamentos" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                        <img src="static/images/icones/calendar.png">
                                        Meus agendamentos
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].controladoria.dicasSemanais" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                        <img src="static/images/icones/writing.png">
                                        Dicas semanais
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].controladoria.receitasAtestados" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                        <img src="static/images/icones/note.png">
                                        Receitas e atestados
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].controladoria.meusExames" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Exames'}" class="button-menu shadow">
                                        <img src="static/images/icones/archives.png">
                                        Meus exames
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].controladoria.meusDocumentos" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Arquivos'}" class="button-menu shadow">
                                        <img src="static/images/icones/diary.png">
                                        Meus documentos
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].controladoria.ged" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Ged'}" class="button-menu shadow">
                                        <img src="static/images/icones/diary.png">
                                        GED
                                    </router-link>
                                </div>        

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].controladoria.pacientes">
                                    <router-link :to="{'name': 'Pacientes'}" class="button-menu shadow">
                                        <img src="static/images/icones/users.png">
                                        Pacientes
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].controladoria.aprovacaoOrcamentaria">
                                    <router-link :to="{'name': 'FinanceiroSolicitacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/receipt.png">
                                        Aprovações
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].controladoria.alteracaoOrcamentaria">
                                    <router-link :to="{'name': 'FinanceiroMovimentacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/refund.png">
                                        Orçamento
                                    </router-link>
                                </div>                                

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].controladoria.minhaConta">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                                <div  class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].controladoria.sair">
                                    <a v-on:click="$root.exit" class="button-menu shadow">
                                        <img src="static/images/icones/warranty.png">
                                        Sair
                                    </a>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>           

                    <div class="row" v-show="$root.user.tipo == 'coordenador'">
                           
                        <div class="col-xs-12">

                            <div class="row">

                                <div v-if="$root.config['menu'].coordenador.agendarConsulta" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Profissionais'}" class="button-menu shadow">
                                        <img src="static/images/icones/stethoscope.png">
                                        Agendar consulta
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].coordenador.meusAgendamentos" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                        <img src="static/images/icones/calendar.png">
                                        Meus agendamentos
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].coordenador.dicasSemanais" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                        <img src="static/images/icones/writing.png">
                                        Dicas semanais
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].coordenador.receitasAtestados" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                        <img src="static/images/icones/note.png">
                                        Receitas e atestados
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].coordenador.meusExames" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Exames'}" class="button-menu shadow">
                                        <img src="static/images/icones/archives.png">
                                        Meus exames
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].coordenador.meusDocumentos" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Arquivos'}" class="button-menu shadow">
                                        <img src="static/images/icones/diary.png">
                                        Meus documentos
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].coordenador.ged" class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Ged'}" class="button-menu shadow">
                                        <img src="static/images/icones/diary.png">
                                        GED
                                    </router-link>
                                </div>        

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].coordenador.pacientes">
                                    <router-link :to="{'name': 'Pacientes'}" class="button-menu shadow">
                                        <img src="static/images/icones/users.png">
                                        Pacientes
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].coordenador.aprovacaoOrcamentaria">
                                    <router-link :to="{'name': 'FinanceiroSolicitacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/receipt.png">
                                        Aprovações
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].coordenador.alteracaoOrcamentaria">
                                    <router-link :to="{'name': 'FinanceiroMovimentacoes'}" class="button-menu shadow">
                                        <img src="static/images/icones/refund.png">
                                        Orçamento
                                    </router-link>
                                </div>                                

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].coordenador.minhaConta">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                                <div  class="col-xs-6 col-xl-3 col-md-6 col-lg-3" v-if="$root.config['menu'].coordenador.sair">
                                    <a v-on:click="$root.exit" class="button-menu shadow">
                                        <img src="static/images/icones/warranty.png">
                                        Sair
                                    </a>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>                             

                    <div class="row" v-show="$root.user.tipo == 'criacao'">
                           
                        <div class="col-xs-12">

                            <div class="row">

                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'UsuariosGeral'}" class="button-menu shadow">
                                        <img src="static/images/icones/user2.png">
                                        Usuários
                                    </router-link>
                                </div>


                                <div class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>

                    <!-- admin -->
                    <div class="row" v-show="$root.user.tipo == 'marketing'">
                           
                        <div class="col-xs-12">
                            <div class="row" v-if="$root.config['menu']">

                                <div v-if="$root.config['menu'].marketing.dicasSemanais" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Posts'}" class="button-menu shadow">
                                        <img src="static/images/icones/writing.png">
                                        Dicas semanais
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].marketing.campanhas" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Campanhas'}" class="button-menu shadow">
                                        <img src="static/images/icones/tick.png">
                                        Campanhas
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].marketing.muralRecados" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Mural'}" class="button-menu shadow">
                                        <img src="static/images/icones/document.png">
                                        Mural de recados
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].marketing.minhaConta" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                            </div>                            
                        </div>                            
                        
                    </div>                    

                    <!-- profissional -->
                    <div class="row" v-if="$root.config['menu']" v-show="$root.user.tipo == 'profissional'">
                        <div class="col-xs-12" v-if="data.agendamentos.itens.length > 0 && $root.config['menu'].profissional.agendamentos">                         
                            <div class="dashboard-box margin-top-0 cards agendamentos">
                                <div class="content">
                                    <h5 class="block-title">
                                        <i class="las la-calendar"></i>
                                        Agendamentos hoje
                                    </h5>
                                    <ul class="dashboard-box-list">
                                        
                                        <li v-for="(item, index) in data.agendamentos.itens">
                                            <router-link v-if="item.DS_CLASSIF_AGENDA != 'Consulta Online'" :to="{'name': 'Paciente', 'query':{'CD_PESSOA_FISICA': item.CD_PESSOA_FISICA}}" class="job-listing card2" >
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                
                                                                <i class="las la-angle-right chevron-right hidden-xl hidden-md" style="opacity: 0.5"></i>
                                                                
                                                                <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                    <i class="las la-clock" style="opacity: 0.5;"></i>    
                                                                    {{item.HR_INICIO | formatDate}}h
                                                                </h3>
                                                                <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                    <i class="las la-user"></i>
                                                                    #{{item.CD_PESSOA_FISICA}} - {{item.NM_PACIENTE}}
                                                                </small>
                                                                <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                    {{item.DS_STATUS_AGENDA}}
                                                                </span>    

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                            <router-link v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" :to="{'name': 'Teleconsulta', 'query': {'NR_SEQUENCIA': item.NR_SEQUENCIA}}" class="job-listing card2" >
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-     12">
                                                                <i class="las la-angle-right chevron-right hidden-xl hidden-md" style="opacity: 0.5"></i>
                                                                
                                                                <h3 class="job-listing-title margin-bottom-0" style="color: #666;">
                                                                    <i class="las la-clock" style="opacity: 0.5;"></i>    
                                                                    {{item.HR_INICIO | formatDate}}h
                                                                </h3>
                                                                <small style="display: block; line-height: 130%; margin-bottom: 5px;">
                                                                    <i class="las la-user"></i>
                                                                    #{{item.CD_PESSOA_FISICA}} - {{item.NM_PACIENTE}}
                                                                </small>
                                                                <span class="dashboard-status-button" style="letter-spacing: 1px; font-size: 12px;" :class="{'green': item.DS_STATUS_AGENDA == 'Executada' || item.DS_STATUS_AGENDA == 'Atendido', 'color-orange': item.DS_STATUS_AGENDA == 'Aguardando', 'color-red': item.DS_STATUS_AGENDA == 'Cancelada' || item.DS_STATUS_AGENDA == 'Falta não justificada', 'color-blue': item.DS_STATUS_AGENDA == 'Em Consulta', 'color-gray': item.DS_STATUS_AGENDA == 'Normal'}">
                                                                    {{item.DS_STATUS_AGENDA}}
                                                                </span>

                                                                <small v-if="item.DS_CLASSIF_AGENDA == 'Consulta Online'" style="color: #000">
                                                                    <i class="las la-video"></i>
                                                                    Teleconsulta
                                                                </small>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>  
                            <div class="hidden-xs margin-top-20"></div>                         
                        </div>
                        <!-- <div class="col-xs-12" v-if="data.agendamentos.itens.length == 0" style="height: 3vh">                          -->
                            
                        <!-- </div> -->
                        <div class="col-xs-12">
                            <div class="row">

                                <div v-if="$root.config['menu'].profissional.agendamentos" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                        <img src="static/images/icones/calendar.png">
                                        Agendamentos
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].profissional.pacientes" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Pacientes'}" class="button-menu shadow">
                                        <img src="static/images/icones/users.png">
                                        Pacientes
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].profissional.honorariosMedicos" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'HonorariosMedicos'}" class="button-menu shadow">
                                        <img src="static/images/icones/wallet.png">
                                        Honorários Médicos
                                    </router-link>
                                </div>                                 

                                <div v-if="$root.config['menu'].profissional.receitasAtestados" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Receitas'}" class="button-menu shadow">
                                        <img src="static/images/icones/note.png">
                                        Receitas e atestados
                                    </router-link>
                                </div>

                                <div v-if="$root.config['menu'].profissional.minhaConta" class="col-xs-6 col-xl-2 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <img src="static/images/icones/profile.png">
                                        Minha conta
                                    </router-link>
                                </div>

                            </div>                            
                        </div>                            
                        

                    </div>                    


                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Dashboard',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "initLoaded":           false,
            "swiperOptions": {
                "speed":            400,
                "autoplay":         {
                    "delay":        1000
                },
                "slidesPerView":    "2",
                "spaceBetween":     10
            },               
            "data":                 {
                "formulariosPendentes": {
                    "total":        0
                },
                "agendamentos":     {
                    "itens":        []
                },
                "mural":     {
                    "itens":        []
                },
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "agendamento",
                "filtro":           "pendentes"
            }              
        }
    },
    computed: {
        agendamentosProximos: function () {
            function compare(a, b) {
                if ((new Date(a.HR_INICIO)).getTime() < (new Date(b.HR_INICIO)).getTime())
                    return -1;
                if ((new Date(a.HR_INICIO)).getTime() > (new Date(b.HR_INICIO)).getTime())
                    return 1;
                return 0;
            }
            return this.data.agendamentos.itens.sort(compare);
        }
    },    
    methods: {
        getFormularios: function() {
            var self        = this;
            console.log("getFormularios()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (!self.$root.logged) {
                    return resolve(true);
                }

                axios.get("api/formularios.php", {
                    params: {
                        "tipo":         "pendentes",
                        "quantidade":   true
                    },
                    authentication:     true 
                })
                .then(response => {
                    
                    console.log("getFormularios() response", response);
                    self.data.formulariosPendentes   = response.data.result; 
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getFormularios() error", error);                    
                    // loading.hide();
                    reject(error);
                });   
            });   
        },         
        getMural: function() {
            var self        = this;
            console.log("getMural()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.tmp.dashboardMural.itens.length > 0) {
                    self.data.mural  = JSON.parse(JSON.stringify(self.$root.tmp.dashboardMural));
                    self.$root.loaded = true;
                    self.initLoaded = true;
                    self.$forceUpdate();
                    loading.hide();
                    resolve(true);
                }

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "inicio":       true
                        // "habilitado":   1
                    }
                };

                axios.get("api/mural.php", form)
                .then(response => {
                    
                    console.log("getMural() response", response);    
                    self.data.mural               = response.data.result; 
                    self.$root.tmp.dashboardMural = JSON.parse(JSON.stringify(response.data.result));
                    self.$forceUpdate();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getMural() error", error);                    
                    reject(error);
                });   
            });   
        },         
        getAgendamentos: function() {
            var self        = this;
            console.log("getAgendamentos()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (!self.$root.logged) {
                    return resolve(true);
                }

                if (self.$root.tmp.dashboardAgendamentos.itens.length > 0) {
                    self.data.agendamentos  = JSON.parse(JSON.stringify(self.$root.tmp.dashboardAgendamentos));
                    self.$forceUpdate();
                    resolve(true);
                }
                
                if (self.$root.user.tipo == "profissional") {
                    self.form.filtro    = "hoje";
                } else if (self.$root.user.tipo == "contratante") {
                    self.form.filtro    = "proximos";
                } else {   
                    return resolve(true);
                }

                axios.get("api/agendamento.php", {params: self.form})
                .then(response => {
                    
                    console.log("getAgendamentos() response", response);
                    self.data.agendamentos      = JSON.parse(JSON.stringify(response.data.result));
                    self.$root.tmp.dashboardAgendamentos = JSON.parse(JSON.stringify(response.data.result));

                    self.$forceUpdate(); 
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getAgendamentos() error", error.response);                    
                    resolve(error);
                });   
            });   
        }, 
        init: function() {
            console.log("init()");
            var self = this;
            loading.show();
            Promise.all([
                self.getAgendamentos(),
                self.getMural(),
                self.getFormularios(),
            ]).then(function() {
                self.initLoaded = true;
                
                if (self.$root.loaded) {
                    if (window.__app.$route.name == "Dashboard") {
                        loading.hide();
                    }
                }
            }).catch(function(error) {
                // loading.hide();
                self.initLoaded = true;
                self.$forceUpdate();  
                if (self.$root.loaded) {

                    loading.hide();
                }              
            });               
        }
    },
    created: function() {
        var self = this;

        if (!self.$root.loaded) {
            $("#wrapper").hide();
            loading.show();
        }
        window._swiper = self.$refs;

        if (self.$root.user.tipo == 'marketing') {
            self.$router.currentRoute.meta.title = "Área do marketing";
        }
        
        if (self.$root.user.tipo == 'contratante') {
            self.$router.currentRoute.meta.title = "Área do paciente";
        }
        
        if (self.$root.user.tipo == 'admin') {
            self.$router.currentRoute.meta.title = "Área de administração";
        }
                                
        if (self.$root.user.tipo == 'profissional') {
            self.$router.currentRoute.meta.title = "Área do profissional";
        }

    },
    mounted: function() {
        
        var self = this;
        self.init();
        if (window.localStorage.getItem("_redirect")) {
            try {
                var redirect = JSON.parse(window.localStorage.getItem("_redirect"));
                if (redirect.route) {
                    redirect.query.r = 1;
                    setTimeout(function() {
                        self.$root.go(redirect.route, JSON.stringify(redirect.query));
                    }, 2000);
                }
            } catch(err) {
                console.log("Erro ao ler _redirect", err);
            }
        }
        setTimeout(function() {
            self.$root.loaded = true;
            $("#wrapper").fadeIn(1000);
            if (self.initLoaded) {
                loading.hide();
            }
            if (self.$refs.swiperConvenios) {
                setTimeout(function() {
                    self.$refs.swiperConvenios.update();
                    self.$refs.swiperConvenios.swiper.autoplay.run();
                }, 1000);
            }


        }, 500);

        if (self.$route.query.t == "popup-sintomas" || window.localStorage.getItem("popup-sintomas") == "true") {

            if (!self.$root.logged) {
                window.localStorage.setItem("popup-sintomas", true);
                self.$root.go("Login");
                return false;
            }
            self.$root.openSintomas();             
        }
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .contato .social {
        display: inline-block;
        margin-right: 3px;
        margin-bottom: 10px;
    }

    .contato center img {
        width: auto;
        height: 11vh;
    }

    .contato small {
        margin-top: 5px;
        display: block;
        line-height: 110%;
        color: #666;
    }

    .contato .social img {
        width: 30px;
        margin: 0px;
        /*opacity: 0.3;*/
    }

/*    .job-listing-description small {
        color: #999;
        font-size: 12px;
    }

    .job-listing-description small i {
        font-size: 14px;
        top: 2px;
        position: relative;
    }*/

    .dashboard-sidebar {
        display: none;
    }  

    .convenios {
        border-color: #1d9dd9;
        min-height: 17vh; 
        height: 100%; 
        padding-top: 20px; 
        justify-content: flex-start !important; 
        vertical-align: top !important;
        background: #fff;
    }

    .convenios .swiper-container {
        /*margin-top: 10px;*/
    }
    .convenios a {
        font-size: 14px;
    }

    .convenios img {
        width: 200px;
    }

    .hidden-web {
        display: none !important;
    }

    .badge {
        position: absolute;
        right: 0px;
        top: -8px;
        width: 40px;
        font-size: 20px;
        line-height: 38px;
        vertical-align: min(0, 0);
        font-weight: 500;
        height: 40px;
        border-radius: 50%;
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue